export default "__VITE_ASSET__ab0be7ed__"